import type {CatalogueMarketplace, LigneDeCommande} from 'api-types/ffconnect';

type LigneDeCommandeTolede = LigneDeCommande['tolede'];

export type LigneDeCommandeAffichage = Pick<
  LigneDeCommande,
  'marketplace_id'
> & {
  tolede: Pick<
    LigneDeCommandeTolede,
    'code_article' | 'ref_tiers' | 'libelle' | 'libelle_commercial'
  >;
};

export interface AffichageLigneDeCommande {
  codeArticle: string;
  libelleFallback: string | undefined;
  marketplaceId: CatalogueMarketplace | undefined;
}

// L'absence de marketplace_id distingue une ligne France Frais d'une ligne marketplace :
// pour FF on affiche le code_article et le libellé commercial, pour une marketplace on
// préfère la ref_tiers et le libellé Tolede issus du fournisseur externe.
export function getAffichageLigneDeCommande(
  ligne: LigneDeCommandeAffichage,
): AffichageLigneDeCommande {
  const {tolede, marketplace_id} = ligne;
  if (!marketplace_id) {
    return {
      codeArticle: tolede.code_article,
      libelleFallback: tolede.libelle_commercial ?? tolede.libelle,
      marketplaceId: undefined,
    };
  }

  return {
    codeArticle: tolede.ref_tiers ?? tolede.code_article,
    libelleFallback: tolede.libelle ?? tolede.libelle_commercial,
    marketplaceId: marketplace_id,
  };
}
